angular.module( 'acme.view.application.programs.detail.photos', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.programs.detail.photos.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var programsDetailPhotos = {
        name: 'application.programsDetail.photos',
        url: '/photos',
        views: {
          "subview-main": {
            controller: 'ProgramsDetailPhotosController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/programs/detail/photos/photos.tpl.html'
          }
        },
        data: {
          pageTitle: 'Photos'
        },
        resolve: {
          ResolveViewData: [ 'ResolveViewData', function(ResolveViewData) {
            return ResolveViewData;
          }]
        }
      };

    $stateProvider
      .state(programsDetailPhotos);
});
